<template>
    <div class="c-take-next-step">
        <div class="c-take-next-step__bg">
            <div class="c-take-next-step__title">
                <component
                    :is="titleTag || 'h3'"
                    class="title"
                >
                    {{ content.custom?.field1 }}
                </component>
            </div>
            <div class="c-take-next-step__content">
                <p class="mb-3">
                    {{ content.custom?.field2 }}
                </p>
                <div class="d-f justify-content-center align-items-center mt-10">
                    <y-row>
                        <y-col
                            md="12"
                            lg="6"
                        >
                            <y-button
                                class="text-box-btn mb-5"
                                color="primary"
                                :tag="isLink(content.custom['field4']) ? 'a' : 'router-link'"
                                :to="content.custom['field4']"
                                :href="content.custom['field4']"
                            >
                                {{ content.custom['field3'] }}
                            </y-button>
                        </y-col>
                        <y-col
                            v-if="!hideSecondButton"
                            md="12"
                            lg="6"
                        >
                            <y-button
                                class="text-box-btn mb-5 trial-btn"
                                color="transparent"
                                :tag="isLink(content.custom['field6']) ? 'a' : 'router-link'"
                                :to="content.custom['field6']"
                                :href="content.custom['field6']"
                            >
                                {{ content.custom['field5'] }}
                            </y-button>
                        </y-col>
                    </y-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'BoostYourMarketing',
        props: {
            content         : Object,
            titleTag        : String,
            hideSecondButton: {
                type   : Boolean,
                default: false,
            },
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
